import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'

import { IStateAndCountiesOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../../options/services/options.service'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { IPatientDemographicsState } from '../store/patientDemographics.types'
import { getPatientDemographicsSelector } from '../selectors'
import { setPatientCountyOptions } from '../../options/store/options.actions'

export function* getPatientCountyOptions() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const optionsService = new OptionsService(serviceId)

    const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
    const { state } = patientDemographics

    const response: IStateAndCountiesOptionsResponse = yield call([optionsService, optionsService.getCountyOptions])
    const { entity } = response

    const foundCountyObject = entity.find((obj) => obj.state === String(state?.id))
    const countiesToSet = foundCountyObject ? foundCountyObject.counties : []

    yield put(setPatientCountyOptions(countiesToSet))
  } catch (e) {
    yield put(throwPcrException(`getPatientCountyOptions() error: ${e}`))
  }
}

export function* getPatientCountyOptionsSaga() {
  yield takeLatest([PatientDemographicsConstants.GET_PATIENT_COUNTY_OPTIONS], getPatientCountyOptions)
}
